import React from "react";
import { RouteConfig } from "../../../routes/AuthRoutes";
import { HeadingComponent } from "../../shared/HeadingComponent";
import { LinkComponent } from "../../shared/LinkComponent";
import { NblocksButton } from "../../shared/NblocksButton";
import { useTranslation } from "react-i18next";
const SetupMfaRecoverCodeComponent = ({
  didClickContinue,
  recoverCode
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement("div", {
    className: "max-w-sm w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "space-y-6 flex flex-col mt-6 md:mt-8 text-center "
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(HeadingComponent, {
    size: "4xl",
    type: "h1",
    className: "inline-block border-solid border border-gray-500 rounded-md py-3 px-4"
  }, recoverCode)), /*#__PURE__*/React.createElement(NblocksButton, {
    size: "md",
    type: "primary",
    fullWidth: true,
    onClick: () => didClickContinue()
  }, t("Continue"))), /*#__PURE__*/React.createElement("div", {
    className: "mt-8 text-center"
  }, /*#__PURE__*/React.createElement(LinkComponent, {
    to: RouteConfig.login.loginScreen,
    type: "secondary",
    className: "font-semibold",
    size: "sm"
  }, t("Back to login"))));
};
export { SetupMfaRecoverCodeComponent };